import React from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {FormattedMessage, useIntl} from "react-intl";
import CancelButton from "../../../../../components/buttons/CancelButton";
import {QRCODE_PAGE_PATH} from "../../../../../constants/Profile";

export type Host2ndDialogProps = {
    onClose: () => void;

    open: boolean;
    code: string;
};

const QRCodeDialog: React.FC<Host2ndDialogProps> = (props) => {
    const intl = useIntl();


    const handleCancel = () => {
        props.onClose();
    }

    const path = QRCODE_PAGE_PATH.replace('${QRCODE}',props.code);

    return (
        <Dialog open={props.open} onClose={handleCancel} fullWidth={true} >
            <DialogTitle>
                <FormattedMessage id={'VMS_REQUEST_VISITOR_VISIT_CODE_QRCODE'}/>
            </DialogTitle>
            <DialogContent>
               <iframe src={path} style={{height:'410px',border:0}}/>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={handleCancel}/>

            </DialogActions>
        </Dialog>
    );
};

export default QRCodeDialog;